import React, { FunctionComponent, memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { SpacingProps } from '../../../utils/styling/StylingHelper'
import { mapSpaceValue } from '../../../Layouts/LayoutUtils'
import TeaserInfo from '../../../TeaserInfo'
import { HeadlineProps } from '../../Match/MatchCard'
import SetRow from '../Row'
import { SetProps } from '../Row/SetRowTypes'
import MoreIcon from '../../../BaseComponents/Icons/MoreIcon'
import TopLabel, { TopLabelProps } from '../../TopLabel'
import HighlightRow from '../../HighlightRow'

export type SetCardProps = {
    headlineProps?: HeadlineProps
    setProps: SetProps
    onPressMore?: () => void
    /**
     * callback when the 'Livestream' button gets pressed
     */
    onPressVideoButton?: () => void
    /**
     * link for the button
     */
    videoButtonHref?: string
    /**
     * text for the button
     */
    videoButtonText?: string
} & TestID &
    Pick<SpacingProps, 'spaceY' | 'spaceTop' | 'spaceBottom'> &
    TopLabelProps

const SetCard: FunctionComponent<SetCardProps> = ({
    headlineProps,
    setProps,
    testID,
    topLabel,
    spaceY,
    spaceBottom,
    spaceTop,
    onPressMore,
    onPressVideoButton,
    videoButtonHref,
    videoButtonText,
}): ReactElement => (
    <Grid
        noExpand
        backgroundColor="pearl"
        border="1px"
        borderColor="moon-2"
        borderRadius={4}
        testID={testID}
        marginY={mapSpaceValue(spaceY)}
        marginBottom={mapSpaceValue(spaceBottom)}
        marginTop={mapSpaceValue(spaceTop)}
        minHeight={66}
    >
        {topLabel ? <TopLabel topLabel={topLabel} onPress={setProps.onPressMatch} /> : null}
        <Grid noExpand paddingTop={topLabel ? 0 : '6px'}>
            {headlineProps ? (
                <Grid paddingX={5} paddingTop={1}>
                    <Touchable onPress={headlineProps.onPressHeadline}>
                        <TeaserInfo
                            hideTagImage={headlineProps.hideTagImage}
                            name={headlineProps.text}
                            imageUrl={headlineProps.imageUrl}
                            alt={headlineProps.alt}
                        />
                    </Touchable>
                </Grid>
            ) : null}
            <Grid horizontal noExpand>
                <SetRow
                    {...setProps}
                    noExpand={false}
                    additionalFieldOffset={6}
                    paddingTop={1}
                    borderRadius={4}
                />
                {onPressMore ? (
                    <Touchable onPress={onPressMore}>
                        <Grid noExpand paddingTop={17} paddingRight={11}>
                            <MoreIcon />
                        </Grid>
                    </Touchable>
                ) : null}
            </Grid>
        </Grid>
        {onPressVideoButton || videoButtonHref ? (
            <HighlightRow
                text={videoButtonText}
                onPress={onPressVideoButton}
                href={videoButtonHref}
                marginBottom={4}
            />
        ) : null}
    </Grid>
)

export default memo(SetCard)
